import React from "react";
import styled from "styled-components";
import { Row, Col, Select } from "antd";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { SearchOutlined } from "@ant-design/icons";
import { ReactComponent as LeftoutlinedIcon } from "../../../assets/images/Leftoutlinedone.svg";
import { ReactComponent as Rightoutlinedone } from "../../../assets/images/rightoutlinedone.svg";

const Wrappercontainer = styled.div`
  .container_dashboard_one {
    display: flex;
    justify-content: space-between;
    padding: 24px 4px 5px 4px;
    gap: 10px;
  }
  .wrapper_column_container {
    background-color: rgb(255, 255, 255);
    border-radius: 13px;
    border: 1px solid rgb(231, 231, 237);
    margin: 14px 0px 14px 0px;
  }
  p {
    line-height: 0px;
    margin: 10px 0px 0px 0px;
    font-size: 17px;
    font-weight: 600;
  }
  .conatiner_sub_four {
    border-radius: 13px;
    border: 2px solid rgb(231, 231, 237);
    margin: 14px 0px 14px 0px;
    padding: 5px 3px 5px 3px;
  }
  .container_dashboard_five {
    display: flex;
    gap: 10px;
  }
  .container_dashboard_subcontainer {
    display: flex;
    align-items:center;
    gap: 10px;
  }
  .containerfor_icon{
    display:flex;
    gap:32px;
    padding:8px;

  }
  .LeftoutlinedIcon_icon{
font-size :22px !important

  }
 

`;

const Productivity = () => {
  const data = [
    { x: "kA12345", Best: 12, Worst: 12 },
    { x: "kA12345", Best: 20, Worst: 14 },
    { x: "kA12345", Best: 15, Worst: 15 },
    { x: "kA12345", Best: 18, Worst: 18 },
    { x: "kA12345", Best: 25, Worst: 22 },
    { x: "kA12345", Best: 20, Worst: 16 },
    { x: "kA12345", Best: 18, Worst: 14 },
    { x: "kA12345", Best: 28, Worst: 22 },
    { x: "kA12345", Best: 22, Worst: 17 },
    { x: "kA12345", Best: 24, Worst: 19 },
  ];
  const dataone = [
    { x: "kA12345", Best: 12, Worst: 12 },
    { x: "kA12345", Best: 20, Worst: 14 },
    { x: "kA12345", Best: 15, Worst: 15 },
    { x: "kA12345", Best: 18, Worst: 18 },
    { x: "kA12345", Best: 25, Worst: 22 },
    { x: "kA12345", Best: 20, Worst: 16 },
    { x: "kA12345", Best: 18, Worst: 14 },
    { x: "kA12345", Best: 28, Worst: 22 },
    { x: "kA12345", Best: 22, Worst: 17 },
    { x: "kA12345", Best: 24, Worst: 19 },
  ];

  const datathree = [
    { x: "William Joseph Becquerel", Best: 12, Worst: 12 },
    { x: "William Joseph Becquerel", Best: 20, Worst: 14 },
    { x: "William Joseph Becquerel", Best: 15, Worst: 15 },
    { x: "William Joseph Becquerel", Best: 18, Worst: 18 },
    { x: "William Joseph Becquerel", Best: 25, Worst: 22 },
    { x: "William Joseph Becquerel", Best: 20, Worst: 16 },
    { x: "William Joseph Becquerel", Best: 18, Worst: 14 },
    { x: "William Joseph Becquerel", Best: 28, Worst: 22 },
    { x: "William Joseph Becquerel", Best: 22, Worst: 17 },
    { x: "William Joseph Becquerel", Best: 24, Worst: 19 },
  ];
  const datafour = [
    { x: "William Joseph Becquerel", Local: 12, Safari: 12 },
    { x: "William Joseph Becquerel", Local: 20, Safari: 14 },
    { x: "William Joseph Becquerel", Local: 15, Safari: 15 },
    { x: "William Joseph Becquerel", Local: 18, Safari: 18 },
    { x: "William Joseph Becquerel", Local: 25, Safari: 22 },
    { x: "William Joseph Becquerel", Local: 20, Safari: 16 },
    { x: "William Joseph Becquerel", Local: 18, Safari: 14 },
    { x: "William Joseph Becquerel", Local: 28, Safari: 22 },
    { x: "William Joseph Becquerel", Local: 22, Safari: 17 },
    { x: "William Joseph Becquerel", Local: 24, Safari: 19 },
  ];

  const datafive = [
    { x: "KA12345", Local: 12, Safari: 12 },
    { x: "KA12345", Local: 20, Safari: 14 },
    { x: "KA12345", Local: 15, Safari: 15 },
    { x: "KA12345", Local: 18, Safari: 18 },
    { x: "KA12345", Local: 25, Safari: 22 },
    { x: "KA12345", Local: 20, Safari: 16 },
    { x: "KA12345", Local: 18, Safari: 14 },
    { x: "KA12345", Local: 28, Safari: 22 },
    { x: "KA12345", Local: 22, Safari: 17 },
    { x: "KA12345", Local: 24, Safari: 19 },
  ];

  const datasix = [
    { x: "KA12345", Local: 12, Safari: 12 },
    { x: "KA12345", Local: 20, Safari: 14 },
    { x: "KA12345", Local: 15, Safari: 15 },
    { x: "KA12345", Local: 18, Safari: 18 },
    { x: "KA12345", Local: 25, Safari: 22 },
    { x: "KA12345", Local: 20, Safari: 16 },
    { x: "KA12345", Local: 18, Safari: 14 },
    { x: "KA12345", Local: 28, Safari: 22 },
    { x: "KA12345", Local: 22, Safari: 17 },
    { x: "KA12345", Local: 24, Safari: 19 },
    { x: "12345", Local: 22, Safari: 17 },
    { x: "12345", Local: 24, Safari: 19 },
  ];

  const dataseven = [
    { x: "Jan", value: 32, valueone: 0 },
    { x: "Feb", value: 20, valueone: 4 },
    { x: "March", value: 15, valueone: 8 },
    { x: "April", value: 18, valueone: 10 },
    { x: "May", value: 25, valueone: 14 },
    { x: "June", value: 20, valueone: 16 },
    { x: "July", value: 18, valueone: 14 },
    { x: "August", value: 28, valueone: 22 },
    { x: "Sept", value: 22, valueone: 17 },
    { x: "Oct", value: 24, valueone: 19 },
    { x: "Nov", value: 22, valueone: 8 },
    { x: "Dec", value: 24, valueone: 6 },
  ];
  return (
    <>
      <Wrappercontainer>
        <Row gutter={16}>
          <Col xl={24} sm={24} className="wrapper_column_container">
            <div className="container_dashboard_one">
              <p>Total Trip: 25</p>
              <div className="container_dashboard_subcontainer">
              <div className="containerfor_icon"  >
                  <span >
              
                    <LeftoutlinedIcon   style={{ fontSize: "24px" }} className="LeftoutlinedIcon_icon"/>
                  </span>
                  <span   >
              
                    <Rightoutlinedone  style={{ fontSize: "24px" }} className="Rightoutlinedone_icon" />
                  </span>
                </div>
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th Aug 2024 - 24th Sep 2024"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div style={{ width: "100%", height: 400 }}>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={data}
                  barCategoryGap={13}
                  margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                  activeBar={false}
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="x"
                    axisLine={false}
                    tickLine={false}
                    interval={0}
                    tick={{
                      fontSize: 12,
                    }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tickInterval={1}
                    domain={[0, 24]}
                    allowDecimals={false}
                    tickCount={13}
                  />
                  <Legend
                    align="center"
                    verticalAlign="top"
                    wrapperStyle={{ top: 5 }}
                  />
                  <Bar
                    dataKey="Best"
                    barSize={20}
                    radius={[5, 5, 2, 2]}
                    stackId="Best"
                    fill="rgb(35,149,241)"
                    fillOpacity={1}
                  />
                  <Bar
                    dataKey="Worst"
                    barSize={20}
                    fillOpacity={1}
                    radius={[5, 5, 2, 2]}
                    stackId="Worst"
                    fill="rgb(255,176,127)"
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Col>

          <Col xl={24} sm={24} className="wrapper_column_container">
            <div className="container_dashboard_one">
              <p>Total Trip: 25</p>
              <div className="container_dashboard_subcontainer">
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="No Sorting"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>
            <div style={{ width: "100%", height: 400 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={dataone}
                  margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="x"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 14 }}
                  />
                  <YAxis
                    domain={[0, 30]}
                    tickCount={13}
                    allowDecimals={false}
                    axisLine={false}
                    tickLine={false}
                  />
                  <Legend align="center" verticalAlign="top" />
                  <Bar
                    dataKey="Best"
                    barSize={35}
                    stackId="a"
                    fill="rgb(109,182,255)"
                    radius={[5, 5, 0, 0]}
                  />
                  <Bar
                    dataKey="Worst"
                    barSize={40}
                    stackId="a"
                    fill="rgb(255,109,168)"
                    radius={[5, 5, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      </Wrappercontainer>

      <Wrappercontainer>
        <Row gutter={16}>
          <Col xl={24} sm={24} className="wrapper_column_container">
            <div className="container_dashboard_one">
              <p>Drivers’ Performance</p>
              <div className="container_dashboard_subcontainer">
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th August 2024"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="container_dashboard_one   ">
              <div
                style={{ width: "100%", height: 400 }}
                className="conatiner_sub_four"
              >
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    barCategoryGap={5}
                    data={datathree}
                    layout="vertical"
                    margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="5 5" horizontal={false} />
                    <XAxis
                      type="number"
                      domain={[0, 30]}
                      allowDecimals={false}
                      axisLine={false}
                      tickLine={false}
                      tickCount={13}
                      label={{
                        value: "Trips Completed",
                        angle: 0, // Keeps the text horizontal
                        position: "insideLeft", // Places it behind the labels
                        offset: -70,
                        style: { fontSize: 8, fill: "#333" },
                      }}
                    />
                    <YAxis
                      dataKey="x"
                      type="category"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 9 }}
                    />
                    <Tooltip />
                    <Legend
                      align="right"
                      verticalAlign="top"
                      wrapperStyle={{ top: 0, right: 0 }}
                    />
                    <Bar
                      dataKey="Best"
                      stackId="a"
                      fill="#FFD361"
                      radius={[0, 4, 4, 0]}
                    />
                    <Bar
                      dataKey="Worst"
                      stackId="a"
                      fill="#6B67EB"
                      radius={[0, 4, 4, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div
                className="conatiner_sub_four"
                style={{ width: "100%", height: 400 }}
              >
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    barCategoryGap={5}
                    data={datafour}
                    layout="vertical"
                    margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="5 5" horizontal={false} />
                    <XAxis
                      type="number"
                      domain={[0, 7]}
                      allowDecimals={false}
                      axisLine={false}
                      tickLine={false}
                      tickCount={14}
                      label={{
                        value: "Trips Completed",
                        angle: 0,
                        position: "insideLeft",
                        offset: -70,
                        style: { fontSize: 8, fill: "#333" },
                      }}
                    />
                    <YAxis
                      dataKey="x"
                      type="category"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 9 }}
                    />
                    <Tooltip />
                    <Legend
                      align="right"
                      verticalAlign="top"
                      wrapperStyle={{ top: 0, right: 0 }}
                    />
                    <Bar
                      dataKey="Local"
                      stackId="a"
                      fill="rgb(112,205,255)"
                      radius={[0, 4, 4, 0]}
                    />
                    <Bar
                      dataKey="Safari"
                      stackId="a"
                      fill="rgb(136,134,183)"
                      radius={[0, 4, 4, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </Col>
        </Row>
      </Wrappercontainer>

      <Wrappercontainer>
        <Row gutter={16}>
          <Col xl={24} sm={24} className="wrapper_column_container">
            <div className="container_dashboard_one">
              <p>Drivers’ Performance</p>
              <div className="container_dashboard_subcontainer">
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="Custom Range"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th August 2024"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div className="container_dashboard_five">
              <div
                style={{ width: "100%", height: 400 }}
                className="conatiner_sub_four"
              >
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    barCategoryGap={5}
                    data={datafive}
                    layout="vertical"
                    margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="5 5" horizontal={false} />
                    <XAxis
                      type="number"
                      domain={[0, 30]}
                      allowDecimals={false}
                      axisLine={false}
                      tickLine={false}
                      tickCount={13}
                      label={{
                        value: "Trips Completed",
                        angle: 0,
                        position: "insideLeft",
                        offset: -70,
                        style: { fontSize: 8, fill: "#333" },
                      }}
                    />
                    <YAxis
                      dataKey="x"
                      type="category"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 9 }}
                    />
                    <Tooltip />
                    <Legend
                      align="right"
                      verticalAlign="top"
                      wrapperStyle={{ top: 0, right: 0 }}
                    />
                    <Bar
                      dataKey="Local"
                      stackId="a"
                      fill="rgb(97,171,255)"
                      radius={[0, 4, 4, 0]}
                    />
                    <Bar
                      dataKey="Safari"
                      stackId="a"
                      fill="rgb(151,71,255)"
                      radius={[0, 4, 4, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div
                className="conatiner_sub_four"
                style={{ width: "100%", height: 400 }}
              >
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    barCategoryGap={5}
                    data={datasix}
                    layout="vertical"
                    margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="5 5" horizontal={false} />
                    <XAxis
                      type="number"
                      domain={[0, 7]}
                      allowDecimals={false}
                      axisLine={false}
                      tickLine={false}
                      tickCount={14}
                      label={{
                        value: "Trips Completed",
                        angle: 0,
                        position: "insideLeft",
                        offset: -70,
                        style: { fontSize: 8, fill: "#333" },
                      }}
                    />
                    <YAxis
                      dataKey="x"
                      type="category"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 9 }}
                    />
                    <Tooltip />
                    <Legend
                      align="right"
                      verticalAlign="top"
                      wrapperStyle={{ top: 0, right: 0 }}
                    />
                    <Bar
                      dataKey="Local"
                      stackId="a"
                      fill="rgb(153,179,210)"
                      radius={[0, 4, 4, 0]}
                    />
                    <Bar
                      dataKey="Safari"
                      stackId="a"
                      fill="rgb(60,112,171)"
                      radius={[0, 4, 4, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </Col>
        </Row>
      </Wrappercontainer>
      <Wrappercontainer>
        <Row gutter={16}>
          <Col xl={24} sm={24} className="wrapper_column_container">
            <div className="container_dashboard_one">
              <p>Drivers’ Performance</p>
              <div className="container_dashboard_subcontainer">
                <div className="containerfor_icon"  >
                  <span >
              
                    <LeftoutlinedIcon   style={{ fontSize: "24px" }} className="LeftoutlinedIcon_icon"/>
                  </span>
                  <span   >
              
                    <Rightoutlinedone  style={{ fontSize: "24px" }} className="Rightoutlinedone_icon" />
                  </span>
                </div>
                <Select
                  className="kpireport_select_filter"
                  showSearch
                  prefix={
                    <SearchOutlined style={{ color: "#999", marginRight: 8 }} />
                  }
                  placeholder="24th August 2024"
                  style={{ width: 220 }}
                  suffixIcon={null}
                />
              </div>
            </div>

            <div style={{ width: "100%", height: 400 }}>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  data={dataseven}
                  margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                >
                  <CartesianGrid
                    stroke="#ccc"
                    strokeDasharray="0"
                    horizontal={false}
                  />
                  <XAxis
                    dataKey="x"
                    axisLine={false}
                    tickLine={false}
                    tickCount={14}
                    tick={{
                      fontSize: 11,
                      fill: "rgb(115,127,154)",
                      dx: 5,
                      dy: 5,
                    }}
                  />
                  <YAxis
                    domain={[0, 40]}
                    axisLine={false}
                    tickLine={false}
                    tickCount={14}
                    tick={{
                      fontSize: 11,
                      fill: "rgb(115,127,154)",
                      dx: -15,
                      dy: 15,
                    }}
                  />
                  <Tooltip />
                  <Legend
                    align="center"
                    verticalAlign="top"
                    wrapperStyle={{ top: 0, right: 0 }}
                    iconType="square"
                  />

                  <Line
                    type="linear"
                    dataKey="value"
                    stroke="rgb(255,160,141)"
                    strokeWidth={3}
                    strokeLinecap="round"
                    dot={{ fill: "rgb(255,160,141)", r: 5 }}
                  />

                  <Line
                    type="linear"
                    dataKey="valueone"
                    stroke="rgb(30,208,134)"
                    strokeWidth={3}
                    strokeLinecap="round"
                    dot={{ fill: "rgb(30,208,134)", r: 5 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      </Wrappercontainer>
    </>
  );
};

export default Productivity;
